// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IBlockTypeWrapper {
  format_version: string;
}
